import { isClient } from '@vueuse/core'

import type {
  EmailOptions,
  SmsOptions,
  WhatsAppOptions,
} from '@brighterly/lib-core-types/support/interfaces'

import {
  buildMailtoUrl,
  buildSmsUrl,
  normalizePhoneForWhatsApp,
} from '@shared/lib/format'

interface ContactLaunchersReturn {
  openWhatsApp: (options: WhatsAppOptions) => void
  openEmail: (options: EmailOptions) => void
  openSms: (options: SmsOptions) => void
}

const open = (url: string): void => { window.open(url, '_blank', 'noopener') }

export const useContactLaunchers = (): ContactLaunchersReturn => {

  const openWhatsApp = ({ phone, text }: WhatsAppOptions): void => {
    if (!isClient) return

    const digits = normalizePhoneForWhatsApp(phone)
    const params = text
      ? `?text=${encodeURIComponent(text)}`
      : ''

    open(`https://wa.me/${digits}${params}`)
  }

  const openEmail = (options: EmailOptions): void => {
    if (!isClient) return

    open(buildMailtoUrl(options))
  }

  const openSms = (options: SmsOptions): void => {
    if (!isClient) return

    open(buildSmsUrl(options))
  }

  return {
    openWhatsApp,
    openEmail,
    openSms,
  }
}
